import { AppNS } from 'app';
import { FileInfo } from 'app/ui/components/multi-file-uploader/MultiFileUploader';

export const parseDocumentResponse = (data: AppNS.Params): FileInfo => {
  return {
    id: data.id,
    documentId: data.id,
    thumbnail: '',
    url: data.file.url,
    uppyId: '',
    name: data.properties.file.fileName,
    isLoaded: true,
    isRemoved: false,

    state: 'uploaded',
    uploadProgress: 100,
  };
};

export const parseAgencyDocumentsResponse = (data: Array<AppNS.Params>): Array<FileInfo> => {
  return data.map((item: AppNS.Params) => {
    return parseSingleDocumentData(item);
  });
};

export const parseAgencyDocumentsData = (data: Array<AppNS.Params>): Array<AppNS.AgencyDocument> => {
  return data.map((item: AppNS.Params) => {
    return {
      id: item.id,
      type: item.type,
      document: {
        id: item.id,
        documentId: item.id,
        thumbnail: '',
        url: item.fileUrl.url,
        uppyId: '',
        name: item.file.fileName,
        isLoaded: true,
        isRemoved: false,
        state: 'uploaded',
        uploadProgress: 100,
      },
    } as AppNS.AgencyDocument;
  });
};

export const parseSingleDocumentData = (data: AppNS.Params): FileInfo => {
  if (!data) {
    return {} as FileInfo;
  }

  return {
    id: data.id,
    documentId: data.id,
    thumbnail: '',
    url: data.fileUrl.url,
    uppyId: '',
    name: data.file.fileName,
    isLoaded: true,
    isRemoved: false,

    state: 'uploaded',
    uploadProgress: 100,
  } as FileInfo;
};
